<template>
  <v-progress-linear
    :value="progress"
    :color="inactive ? 'white' : 'primary'"
    height="12"
    rounded
  >
    <strong v-if="inactive">--</strong>
    <strong v-else class="caption white--text">
      {{ Math.ceil(progress) }}%
    </strong>
  </v-progress-linear>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.extend({
  name: "ActionsProgress",
  data() {
    return {};
  },
  props: {
    item: VueTypes.any.def({}),
  },
  methods: {},
  computed: {
    progress(): number {
      return this.item.progress || 0;
    },
    inactive(): boolean {
      return this.item.progress === 0;
    },
  },
  components: {},
});
</script>
